import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-location_ic",
  "use": "icon-location_ic-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-location_ic\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h28v28H0z\" /><path d=\"M25.667 23.333H2.333V21H3.5v-8.13C3.5 7.05 8.202 2.332 14 2.332S24.5 7.05 24.5 12.87V21h1.167v2.333ZM5.833 21h16.334v-8.13c0-4.53-3.657-8.203-8.167-8.203S5.833 8.339 5.833 12.87V21Zm5.25 3.5h5.834a2.917 2.917 0 0 1-5.834 0Z\" fill=\"#F39B13\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol